/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.21.0
 */

import { pageApi } from '@/main/api/page.api';
import { userNotificationsTags } from '@/main/modules/app/apiTags';
import { EHttpMethod } from '@/main/modules/app/appConstants';
import { invalidateOnSuccess } from '@/main/utils/invalidateOnSuccess';

import { IOrderIdInfoResponse, orderIdInfoResponseMapping } from './mapping';
import { IOrderIdFileModal, IOrderIdInfo, IOrderIdQuery } from './types';

export const orderIdApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        getOrderIdMeta: builder.query<IOrderIdInfo, IOrderIdQuery>({
            query: ({ orderId }) => `/order/${orderId}/meta`,
            transformResponse: (response: IOrderIdInfoResponse) => orderIdInfoResponseMapping(response),
        }),
        sendOrderIdFile: builder.mutation<void, IOrderIdFileModal & IOrderIdQuery>({
            query: ({ orderId, ...rest }) => ({
                url: `order/${orderId}/file/send`,
                method: EHttpMethod.POST,
                body: rest,
            }),
        }),
        sendOrderIdViewed: builder.mutation<void, IOrderIdQuery>({
            query: ({ orderId }) => ({
                url: `order/${orderId}/viewed`,
                method: EHttpMethod.PUT,
            }),
            invalidatesTags: (_result, error) =>
                invalidateOnSuccess(error, [userNotificationsTags.USER_NOTIFICATIONS_LIST]),
        }),
    }),
});

export const { useGetOrderIdMetaQuery, useSendOrderIdFileMutation, useSendOrderIdViewedMutation } = orderIdApi;
